import { getCatalog, getCatalogSourceLabel } from "./catalogo-api-catalogApi.js?v=disponible-20260513-currency-2";
import { createCart } from "./catalogo-components-cart.js?v=disponible-20260908-warehouse-picker-1";
import { createCatalogGrid } from "./catalogo-components-catalogGrid.js?v=disponible-20260630-asesoria-2";
import { createFilters } from "./catalogo-components-filters.js?v=disponible-20260513-currency-2";
import { createMagazineView } from "./catalogo-components-magazineView.js?v=disponible-20260630-asesoria-1";
import { createPagination } from "./catalogo-components-pagination.js?v=disponible-20260511-2";
import { triggerWholesaleAnimation } from "./catalogo-components-wholesaleAnimation.js?v=disponible-20260511-2";
import {
    buildFilterChips,
    escapeHtml,
    filterProducts,
    normalizeCatalog,
    paginateItems,
    sortProducts,
    applyWholesale
} from "./catalogo-utils-helpers.js?v=disponible-20260513-currency-2";


if (window.CATALOG_ASSETS_BASE && window.CATALOG_ASSETS_BASE.includes('?')) {
    window.CATALOG_ASSETS_BASE = window.CATALOG_ASSETS_BASE.split('?')[0];
}

const PAGE_SIZE = 6;
const MOBILE_VIEW_MEDIA_QUERY = "(max-width: 900px)";
const PDF_WITH_PRICE_URL = "https://colors-talleres-machotes-public.s3.amazonaws.com/catalog_PDF/catalogo.pdf";
const PDF_WITHOUT_PRICE_URL = "https://colors-talleres-machotes-public.s3.amazonaws.com/catalog_PDF/catalogo_sin_precio.pdf";
const PDF_AVAILABLE_CATALOG_URL = "https://colors-talleres-machotes-public.s3.us-east-1.amazonaws.com/catalog_PDF/catalogo+disponible.pdf";
const IS_AVAILABLE_CATALOG = () => window.CATALOG_MODE === "available" || window.CATALOG_FORCE_LOCAL_DATA;

function downloadFile(url, filename) {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener";
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
}

function getCurrencyCatalogUrl(currency) {
    return currency === "USD"
        ? window.CATALOG_DISPONIBLE_CATALOG_USD_DATA_URL
        : window.CATALOG_DISPONIBLE_CATALOG_DATA_URL;
}

function applyCatalogCurrency(currency) {
    const selectedCurrency = currency === "USD" ? "USD" : "COP";
    const catalogUrl = getCurrencyCatalogUrl(selectedCurrency);

    window.CATALOG_SELECTED_CURRENCY = selectedCurrency;

    if (catalogUrl) {
        window.CATALOG_DATA_URL = catalogUrl;
        window.CATALOG_API_URL = catalogUrl;
    }
}

function renderShell(root) {
    root.innerHTML = `
        <header class="catalog-header-bar">
            <div class="catalog-header-bar__inner">
                <div class="brand-lockup">
                    <img class="brand-logo" src=\"${window.CATALOG_ASSETS_BASE}catalogo-logo.png" alt="Colors">
                </div>
                <div class="header-actions">
                    <button type="button" id="downloadButton" class="header-icon-btn" title="Descargar PDF">
                        <span class="header-icon" style="display: flex; align-items: center; justify-content: center;">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                <polyline points="7 10 12 15 17 10"></polyline>
                                <line x1="12" y1="15" x2="12" y2="3"></line>
                            </svg>
                        </span>
                    </button>
                    <button type="button" id="shareButton" class="header-icon-btn" title="Compartir enlace">
                        <span class="header-icon" style="display: flex; align-items: center; justify-content: center;">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="18" cy="5" r="3"></circle>
                                <circle cx="6" cy="12" r="3"></circle>
                                <circle cx="18" cy="19" r="3"></circle>
                                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                            </svg>
                        </span>
                    </button>
                    <div class="header-page-pill" title="Total de paginas">
                        <span>Paginas</span>
                        <strong id="headerPageInfo">1 / 1</strong>
                    </div>
                    <button type="button" id="openCartButton" class="header-icon-btn header-cart-btn" title="Ver carrito">
                        <img src=\"${window.CATALOG_ASSETS_BASE}catalogo-carrito_compras.gif" alt="Carrito">
                        <span class="header-cart-count" id="cartCount">0</span>
                    </button>
                </div>
            </div>
        </header>

        <div class="app-shell">
            <div class="app-metrics" hidden>
                <strong id="heroProducts">0</strong>
                <strong id="heroCategories">0</strong>
                <strong id="heroView">Grid</strong>
            </div>

            <div class="catalog-layout">
                <aside id="filtersRoot" class="sidebar-panel surface"></aside>

                <main class="catalog-panel surface">
                    <div class="catalog-toolbar">
                        <div class="toolbar-copy">
                            <h2 class="section-title section-title--lg">Productos</h2>
                            <p class="section-copy">La vista cuadrícula mantiene detalle lateral. La vista revista recupera el paso de hoja y el carrusel inferior.</p>
                        </div>
                        <div class="toolbar-actions">
                            ${IS_AVAILABLE_CATALOG() ? `
                                <select id="currencySelect" class="select-control toolbar-select" aria-label="Seleccionar moneda">
                                    <option value="COP">COP</option>
                                    <option value="USD">USD</option>
                                </select>
                            ` : ""}
                            <div class="mayoristas-sort-group">
                                <label class="mayoristas-toggle" for="mayoristasCheck" title="Mostrar solo referencias con stock mayorista">
                                    <input type="checkbox" id="mayoristasCheck" checked>
                                    <span>Mayoristas</span>
                                </label>
                                <select id="sortSelect" class="select-control toolbar-select" aria-label="Ordenar catalogo">
                                <option value="featured">Destacados</option>
                                <option value="price-asc">Precio menor</option>
                                <option value="price-desc">Precio mayor</option>
                                <option value="stock-desc">Mayor stock</option>
                                <option value="discount-desc">Mayor descuento</option>
                                <option value="reference-asc">Referencia A-Z</option>
                                </select>
                            </div>
                            <div class="view-switcher" id="viewSwitcher">
                                <span class="view-label">Vista</span>
                                <button type="button" class="view-btn active" data-view="grid">Cuadricula</button>
                                
                            </div>
                            <button type="button" id="mobileFilterToggle" class="ghost-button mobile-only">Filtros</button>
                            <button type="button" id="reloadButton" class="ghost-button">Actualizar</button>
                        </div>
                    </div>

                    <div id="statusRoot" hidden></div>
                    <div id="fileFallback" class="file-fallback" hidden>
                        <div class="status-message" data-tone="warning">
                            Estas abriendo el frontend con <code>file://</code>. Si el navegador bloquea la carga automatica, selecciona el JSON manualmente.
                        </div>
                        <p>Selecciona <code>catalogo.json</code> para seguir trabajando sin servidor local.</p>
                        <input id="localFileInput" class="upload-input" type="file" accept=".json,application/json">
                    </div>

                    <div class="toolbar-meta">
                        <div class="results-copy">
                            <strong id="resultsCount">0</strong>
                            <span id="resultsSummary">resultados</span>
                        </div>
                        <div id="activeFilters" class="active-filters"></div>
                    </div>

                    <section id="gridRoot" class="catalog-grid" aria-live="polite"></section>
                    <section id="magazineRoot" hidden></section>
                    <section id="paginationRoot"></section>
                </main>
            </div>
        </div>

        <div id="cartRoot"></div>
        <div id="imageModalRoot"></div>
        <div id="downloadModalRoot"></div>
        <div id="warehousePickerModalRoot"></div>
        <div id="toastRoot" class="toast-container"></div>
    `;
}

let statusTimeout = null;

function renderStatus(container, tone, message, duration = 3000) {
    if (statusTimeout) {
        window.clearTimeout(statusTimeout);
        statusTimeout = null;
    }

    if (!message) {
        container.hidden = true;
        container.innerHTML = "";
        return;
    }

    container.hidden = false;
    container.innerHTML = `<div class="status-message" data-tone="${tone}">${message}</div>`;

    if (duration > 0) {
        statusTimeout = window.setTimeout(() => {
            container.hidden = true;
            container.innerHTML = "";
            statusTimeout = null;
        }, duration);
    }
}

export function showToast(message) {
    const container = document.getElementById("toastRoot");
    if (!container) return;

    const toast = document.createElement("div");
    toast.className = "toast-notification";
    toast.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
        <span></span>
    `;
    toast.querySelector("span").textContent = message;
    container.appendChild(toast);

    window.requestAnimationFrame(() => {
        toast.classList.add("visible");
    });

    window.setTimeout(() => {
        toast.classList.remove("visible");
        const onEnd = () => {
            toast.removeEventListener("transitionend", onEnd);
            toast.remove();
        };
        toast.addEventListener("transitionend", onEnd);
    }, 3000);
}

function parseLocalFile(file) {
    return file.text().then((content) => JSON.parse(content));
}

async function shareCatalogLink() {
    const url = window.location.href;

    if (navigator.share) {
        try {
            await navigator.share({
                title: "Catalogo Colors",
                text: "Mira este catalogo",
                url
            });
            return;
        } catch (error) {
            if (error?.name === "AbortError") {
                return;
            }
        }
    }

    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        window.alert("Link del catalogo copiado al portapapeles.");
        return;
    }

    window.prompt("Copia este link del catalogo:", url);
}

function createImageModal(container) {
    let currentImage = "";

    function render() {
        if (!currentImage) {
            container.innerHTML = "";
            document.body.classList.remove("modal-open");
            return;
        }

        container.innerHTML = `
            <div class="image-modal visible" role="dialog" aria-modal="true" aria-label="Vista ampliada">
                <button class="image-modal__close" type="button" data-action="close-image" aria-label="Cerrar vista ampliada">&times;</button>
                <img class="image-modal__content" src="${currentImage}" alt="Vista ampliada del producto">
            </div>
        `;
        document.body.classList.add("modal-open");
    }

    function open(imageUrl) {
        if (!imageUrl) {
            return;
        }

        currentImage = imageUrl;
        render();
    }

    function close() {
        currentImage = "";
        render();
    }

    container.addEventListener("click", (event) => {
        if (event.target.classList.contains("image-modal") || event.target.closest('[data-action="close-image"]')) {
            close();
        }
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && currentImage) {
            close();
        }
    });

    return { open, close };
}

function createDownloadDialog(container) {
    let visible = false;

    function render() {
        if (!visible) {
            container.innerHTML = "";
            document.body.classList.remove("modal-open");
            return;
        }

        container.innerHTML = `
            <div class="image-modal visible" role="dialog" aria-modal="true" aria-label="Descargar catálogo">
                <div class="download-dialog">
                    <button class="image-modal__close" type="button" data-action="close-download" aria-label="Cerrar">&times;</button>
                    <h3 class="download-dialog__title">Descargar catálogo</h3>
                    <p class="download-dialog__subtitle">¿Deseas descargar el catálogo con precios o sin precios?</p>
                    <div class="download-dialog__actions">
                        <button type="button" class="download-dialog__btn download-dialog__btn--primary" data-action="download-with-price">Con precio</button>
                        <button type="button" class="download-dialog__btn" data-action="download-without-price">Sin precio</button>
                    </div>
                </div>
            </div>
        `;
        document.body.classList.add("modal-open");
    }

    function open() {
        visible = true;
        render();
    }

    function close() {
        visible = false;
        render();
    }

    container.addEventListener("click", (event) => {
        if (event.target.classList.contains("image-modal") || event.target.closest('[data-action="close-download"]')) {
            close();
            return;
        }

        if (event.target.closest('[data-action="download-with-price"]')) {
            downloadFile(PDF_WITH_PRICE_URL, "catalogo.pdf");
            close();
            return;
        }

        if (event.target.closest('[data-action="download-without-price"]')) {
            downloadFile(PDF_WITHOUT_PRICE_URL, "catalogo-sin-precio.pdf");
            close();
        }
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && visible) {
            close();
        }
    });

    return { open, close };
}

function renderWarehousePickerList(status, warehouses, pendingSelectedId, errorMessage) {
    if (status === "loading" || status === "idle") {
        return `<p class="cart-warehouse__status">Buscando almacenes disponibles...</p>`;
    }

    if (status === "loaded") {
        return `
            <div class="cart-warehouse__list">
                ${warehouses.map((warehouse) => {
                    const id = String(warehouse.id);
                    const label = `${warehouse.name} - ${warehouse.address}, ${warehouse.municipio}, ${warehouse.departamento}`;
                    const checked = String(pendingSelectedId) === id ? "checked" : "";
                    return `
                        <label class="cart-warehouse__option">
                            <input type="radio" name="warehouse-picker" data-action="pick-warehouse" data-warehouse-id="${escapeHtml(id)}" ${checked}>
                            <span>${escapeHtml(label)}</span>
                        </label>
                    `;
                }).join("")}
            </div>
        `;
    }

    if (status === "empty") {
        return `<p class="cart-warehouse__status" data-tone="warning">No encontramos un almacen disponible, comuniquese al 311 7463116</p>`;
    }

    return `
        <p class="cart-warehouse__status" data-tone="error">${escapeHtml(errorMessage || "No fue posible consultar los almacenes disponibles.")}</p>
        <button type="button" class="cart-warehouse__retry" data-action="retry-warehouse-picker">Reintentar</button>
    `;
}

function createWarehousePickerDialog(container, cart) {
    let visible = false;
    let pendingSelectedId = null;

    function render() {
        if (!visible) {
            container.innerHTML = "";
            document.body.classList.remove("modal-open");
            return;
        }

        const status = cart.getWarehousesStatus();
        const warehouses = cart.getWarehouses();
        const errorMessage = cart.getWarehousesErrorMessage();
        const canSave = status === "loaded" && Boolean(pendingSelectedId);

        container.innerHTML = `
            <div class="image-modal visible" role="dialog" aria-modal="true" aria-label="Selecciona tu almacen">
                <div class="download-dialog">
                    <button class="image-modal__close" type="button" data-action="close-warehouse-picker" aria-label="Cerrar">&times;</button>
                    <h3 class="download-dialog__title">Selecciona tu almacen</h3>
                    <p class="download-dialog__subtitle">Elige el almacen donde recogeras tu pedido</p>
                    ${renderWarehousePickerList(status, warehouses, pendingSelectedId, errorMessage)}
                    <div class="download-dialog__actions">
                        <button type="button" class="download-dialog__btn" data-action="cancel-warehouse-picker">Cancelar</button>
                        <button type="button" class="download-dialog__btn download-dialog__btn--primary" data-action="save-warehouse-picker" ${canSave ? "" : "disabled"}>Guardar</button>
                    </div>
                </div>
            </div>
        `;
        document.body.classList.add("modal-open");
    }

    async function open() {
        visible = true;
        pendingSelectedId = cart.getSelectedWarehouseId();
        render();
        await cart.ensureWarehousesLoaded();
        render();
    }

    function close() {
        visible = false;
        render();
    }

    container.addEventListener("click", (event) => {
        if (event.target.classList.contains("image-modal") ||
            event.target.closest('[data-action="close-warehouse-picker"]') ||
            event.target.closest('[data-action="cancel-warehouse-picker"]')) {
            close();
            return;
        }

        const pickNode = event.target.closest('[data-action="pick-warehouse"]');
        if (pickNode) {
            pendingSelectedId = pickNode.dataset.warehouseId;
            render();
            return;
        }

        if (event.target.closest('[data-action="retry-warehouse-picker"]')) {
            render();
            cart.ensureWarehousesLoaded().then(render);
            return;
        }

        if (event.target.closest('[data-action="save-warehouse-picker"]')) {
            if (!pendingSelectedId) {
                return;
            }
            cart.selectWarehouse(pendingSelectedId);
            close();
            cart.open();
        }
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && visible) {
            close();
        }
    });

    return { open, close };
}

export function initApp() {
    const root = document.querySelector("#app");
    if (!root) {
        return;
    }

    window.CatalogAnalytics?.init(IS_AVAILABLE_CATALOG() ? "catalogo_disponible" : "catalogo");
    applyCatalogCurrency("COP");
    renderShell(root);

    const appShell = root.querySelector(".app-shell");
    const sortSelect = root.querySelector("#sortSelect");
    const currencySelect = root.querySelector("#currencySelect");
    const reloadButton = root.querySelector("#reloadButton");
    const mobileFilterToggle = root.querySelector("#mobileFilterToggle");
    const resultsCount = root.querySelector("#resultsCount");
    const resultsSummary = root.querySelector("#resultsSummary");
    const activeFiltersNode = root.querySelector("#activeFilters");
    const heroProducts = root.querySelector("#heroProducts");
    const heroCategories = root.querySelector("#heroCategories");
    const heroView = root.querySelector("#heroView");
    const headerPageInfo = root.querySelector("#headerPageInfo");
    const statusRoot = root.querySelector("#statusRoot");
    const localFileInput = root.querySelector("#localFileInput");
    const fileFallback = root.querySelector("#fileFallback");
    const viewButtons = [...root.querySelectorAll(".view-btn")];
    const magazineViewButton = viewButtons.find((button) => button.dataset.view === "magazine") ?? null;
    const mobileViewport = window.matchMedia(MOBILE_VIEW_MEDIA_QUERY);
    const gridRoot = root.querySelector("#gridRoot");
    const magazineRoot = root.querySelector("#magazineRoot");
    const filtersRoot = root.querySelector("#filtersRoot");
    const paginationRoot = root.querySelector("#paginationRoot");
    const downloadButton = root.querySelector("#downloadButton");
    const shareButton = root.querySelector("#shareButton");
    const openCartButton = root.querySelector("#openCartButton");
    const countNode = root.querySelector("#cartCount");

    const imageModal = createImageModal(root.querySelector("#imageModalRoot"));
    const downloadDialog = createDownloadDialog(root.querySelector("#downloadModalRoot"));

    const state = {
        allProducts: [],
        filteredProducts: [],
        selectedReference: "",
        gridPage: 1,
        magazinePage: 1,
        sortBy: "featured",
        view: "grid",
        currency: window.CATALOG_SELECTED_CURRENCY === "USD" ? "USD" : "COP",
        isWholesale: false,
        mayoristas: true
    };
    let wasMobileViewport = mobileViewport.matches;

    function setHeaderPage(currentPage, totalPages) {
        headerPageInfo.textContent = `${currentPage} / ${totalPages}`;
    }

    function findProduct(reference) {
        return state.allProducts.find((product) => product.reference === String(reference)) ?? null;
    }

    const cart = createCart({
        container: root.querySelector("#cartRoot"),
        countNode,
        onChange: ({ totalItems, isWholesale }) => {
            const becameWholesale = isWholesale && !state.isWholesale;
            state.isWholesale = isWholesale;

            if (becameWholesale) {
                triggerWholesaleAnimation();
            }

            syncView();
        }
    });

    const warehousePickerDialog = createWarehousePickerDialog(root.querySelector("#warehousePickerModalRoot"), cart);

    if (currencySelect) {
        currencySelect.value = state.currency;
    }

    function setVariantError(buttonNode, message) {
        const card = buttonNode?.closest(".product-card");
        const errorNode = card?.querySelector('[data-role="variant-error"]');

        if (!errorNode) {
            if (message) {
                showToast(message);
            }
            return;
        }

        errorNode.hidden = !message;
        errorNode.textContent = message || "";
    }

    function buildProductForCart(product, selectedVariant) {
        const hasRawVariants = IS_AVAILABLE_CATALOG() && Array.isArray(product?.raw?.variants) && product.raw.variants.length > 0;

        if (!hasRawVariants) {
            return product;
        }

        const selectedColor = String(selectedVariant?.color || "").trim();
        const selectedSize = String(selectedVariant?.size || "").trim();
        const availableQuantity = Number(selectedVariant?.quantity || 0);

        if (!selectedColor) {
            throw new Error("Selecciona un color.");
        }

        if (!selectedSize) {
            throw new Error("Selecciona una talla.");
        }

        if (availableQuantity <= 0) {
            throw new Error("La combinacion seleccionada no tiene unidades disponibles.");
        }

        return {
            ...product,
            selectedColor,
            selectedSize,
            availableQuantity,
            cartLineId: `${product.reference}::${selectedColor}::${selectedSize}`,
            observation: `Color: ${selectedColor} / Talla: ${selectedSize}`
        };
    }

    function addToCartByReference(reference, buttonNode = null, selectedVariant = null) {
        const product = findProduct(reference);
        if (!product) {
            return;
        }

        window.CatalogAnalytics?.trackInteraction("catalog_add_to_cart_click", {
            accion_catalogo: "agregar_al_carrito",
            etiqueta_boton: "Agregar al carrito",
            item_id: String(product.reference || ""),
            item_name: String(product.description || ""),
            category: String(product.category || ""),
            price: Number(product.price || 0)
        });

        let productForCart = product;

        try {
            productForCart = buildProductForCart(product, selectedVariant);
            setVariantError(buttonNode, "");
        } catch (error) {
            setVariantError(buttonNode, error.message);
            return;
        }

        if (buttonNode) {
            if (buttonNode.classList.contains("btn-is-loading") || buttonNode.classList.contains("btn-is-success")) {
                return;
            }

            const isIconBtn = buttonNode.classList.contains("icon-button") || buttonNode.classList.contains("add-cart-btn");
            const originalHTML = buttonNode.innerHTML;
            const originalWidth = buttonNode.offsetWidth;

            if (originalWidth > 0 && !isIconBtn) {
                buttonNode.style.width = `${originalWidth}px`;
            }

            buttonNode.classList.add("btn-is-loading");

            window.setTimeout(() => {
                buttonNode.classList.remove("btn-is-loading");
                buttonNode.classList.add("btn-is-success");

                if (isIconBtn) {
                    buttonNode.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
                } else {
                    buttonNode.textContent = "¡Agregado!";
                }

                const result = cart.add(productForCart);
                if (result?.ok !== false) {
                    window.CatalogAnalytics?.trackAddToCart(productForCart, result?.cart);
                    cart.open();
                }
                showToast(result?.message || `Referencia ${product.reference} agregada al carrito`);

                window.setTimeout(() => {
                    buttonNode.classList.remove("btn-is-success");
                    buttonNode.innerHTML = originalHTML;
                    buttonNode.style.width = "";
                }, 2000);
            }, 500);
        } else {
            const result = cart.add(productForCart);
            if (result?.ok !== false) {
                window.CatalogAnalytics?.trackAddToCart(productForCart, result?.cart);
                cart.open();
            }
            showToast(result?.message || `Referencia ${product.reference} agregada al carrito`);
        }
    }

    const filters = createFilters({
        container: root.querySelector("#filtersRoot"),
        onChange: () => {
            state.gridPage = 1;
            state.magazinePage = 1;
            syncView();
        }
    });

    const grid = createCatalogGrid({
        container: gridRoot,
        onSelect: async (reference) => {
            state.selectedReference = reference;
            const product = findProduct(reference);
            if (product?.primaryImage) {
                imageModal.open(product.primaryImage);
            }
        },
        onAddToCart: addToCartByReference,
        onPreviewImage: imageModal.open
    });

    const magazine = createMagazineView({
        container: magazineRoot,
        onAddToCart: addToCartByReference,
        onPreviewImage: imageModal.open,
        onProductViews: (products) => window.CatalogAnalytics?.trackProductViews(products),
        onPageInfoChange: ({ currentPage, totalPages }) => {
            state.magazinePage = currentPage;
            setHeaderPage(currentPage, totalPages);
        }
    });

    const pagination = createPagination({
        container: paginationRoot,
        onChange: (page) => {
            state.gridPage = page;
            syncView();
            root.querySelector(".catalog-panel")?.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    });

    function syncStats(products) {
        heroProducts.textContent = String(products.length);
        heroCategories.textContent = String(new Set(products.map((product) => product.category)).size);
        heroView.textContent = state.view === "grid" ? "Grid" : "Revista";
    }

    function syncChips(filtersState) {
        const chips = buildFilterChips(filtersState);
        activeFiltersNode.innerHTML = chips.length > 0
            ? chips.map((chip) => `<span class="filter-chip">${chip}</span>`).join("")
            : `<span class="filter-chip">Sin filtros activos</span>`;
    }

    function syncViewAvailability({ notify = false } = {}) {
        const magazineAvailable = !mobileViewport.matches && !IS_AVAILABLE_CATALOG();

        if (magazineViewButton) {
            magazineViewButton.disabled = !magazineAvailable;
            magazineViewButton.setAttribute("aria-disabled", String(!magazineAvailable));
            magazineViewButton.title = magazineAvailable
                ? "Cambiar a vista revista"
                : IS_AVAILABLE_CATALOG()
                    ? "La vista revista no esta disponible en catalogo disponible"
                    : "La vista revista no esta disponible en celular";
        }

        if (!magazineAvailable && state.view === "magazine") {
            state.view = "grid";

            if (notify) {
                showToast("La vista Revista no esta disponible en celular.");
            }

            return true;
        }

        return false;
    }

    function syncViewButtons() {
        viewButtons.forEach((button) => {
            button.classList.toggle("active", button.dataset.view === state.view);
        });
    }

    function syncGridView(sortedProducts) {
        appShell.classList.remove("view-magazine");
        gridRoot.hidden = false;
        magazineRoot.hidden = true;

        const paginationState = paginateItems(sortedProducts, state.gridPage, PAGE_SIZE);
        state.gridPage = paginationState.page;

        grid.render(paginationState.items);
        window.CatalogAnalytics?.trackProductViews(paginationState.items);
        pagination.render(paginationState);
        setHeaderPage(paginationState.page, paginationState.totalPages);

        if (sortedProducts.length === 0) {
            state.selectedReference = "";
            return;
        }

        const selectedStillVisible = sortedProducts.some((product) => product.reference === state.selectedReference);
        const nextReference = selectedStillVisible ? state.selectedReference : sortedProducts[0].reference;

        if (nextReference !== state.selectedReference) {
            state.selectedReference = nextReference;
            return;
        }

        if (!state.selectedReference) {
            state.selectedReference = sortedProducts[0].reference;
        }
    }

    function syncMagazineView(sortedProducts) {
        appShell.classList.add("view-magazine");
        gridRoot.hidden = true;
        magazineRoot.hidden = false;
        paginationRoot.innerHTML = "";
        magazine.setProducts(sortedProducts, state.magazinePage);
    }

    function syncView() {
        syncViewAvailability();

        const filtersState = filters.getState();

        const processedProducts = state.allProducts.map(product => applyWholesale(product, state.isWholesale));

        const filtered = filterProducts(processedProducts, filtersState);
        const stockFiltered = state.mayoristas
            ? filtered.filter(p => p.stock >= 6)
            : filtered.filter(p => p.stock >= 2);
        const sorted = sortProducts(stockFiltered, state.sortBy);

        state.filteredProducts = sorted;

        resultsCount.textContent = String(sorted.length);
        resultsSummary.textContent = sorted.length === 1 ? "resultado" : "resultados";
        syncStats(sorted);
        syncChips(filtersState);
        syncViewButtons();

        if (state.view === "magazine") {
            syncMagazineView(sorted);
        } else {
            syncGridView(sorted);
        }
    }

    async function loadData({ throwOnError = false, resetPages = false } = {}) {
        const sourceLabel = escapeHtml(getCatalogSourceLabel());
        renderStatus(statusRoot, "success", `Cargando catalogo desde <code>${sourceLabel}</code>...`, 0);

        try {
            const products = await getCatalog();
            state.allProducts = products;
            if (resetPages) {
                state.gridPage = 1;
                state.magazinePage = 1;
                state.view = "grid";
            }
            filters.hydrate(products);
            renderStatus(statusRoot, "success", `Catalogo cargado con ${products.length} referencias desde <code>${sourceLabel}</code>.`, 3000);

            if (window.location.protocol === "file:") {
                fileFallback.hidden = false;
            }

            return products;
        } catch (error) {
            console.error(error);
            const safeMessage = escapeHtml(error?.message ?? "Error desconocido");
            const safeStack = escapeHtml(error?.stack ?? "");
            const details = safeStack ? `<br><small>${safeStack}</small>` : "";
            renderStatus(
                statusRoot,
                "error",
                `No fue posible cargar el catalogo desde <code>${sourceLabel}</code> ni desde <code>${escapeHtml(window.CATALOG_DATA_URL || "catalogo-data.json")}</code>. Detalle del error: ${safeMessage}${details}`,
                0
            );

            if (window.location.protocol === "file:") {
                fileFallback.hidden = false;
            }

            if (throwOnError) {
                throw error;
            }

            return null;
        }
    }

    async function changeCurrency(nextCurrency) {
        const normalizedCurrency = nextCurrency === "USD" ? "USD" : "COP";

        if (!IS_AVAILABLE_CATALOG() || normalizedCurrency === state.currency) {
            return;
        }

        const previousCurrency = state.currency;
        const previousDataUrl = window.CATALOG_DATA_URL;
        const previousApiUrl = window.CATALOG_API_URL;
        const previousSelectedCurrency = window.CATALOG_SELECTED_CURRENCY;

        applyCatalogCurrency(normalizedCurrency);
        state.currency = normalizedCurrency;

        try {
            await loadData({ throwOnError: true, resetPages: true });
            cart.clear();
            showToast(`Catalogo actualizado a ${normalizedCurrency}`);
        } catch (error) {
            window.CATALOG_SELECTED_CURRENCY = previousSelectedCurrency;
            window.CATALOG_DATA_URL = previousDataUrl;
            window.CATALOG_API_URL = previousApiUrl;
            state.currency = previousCurrency;
            if (currencySelect) {
                currencySelect.value = previousCurrency;
            }
            const attemptedUrl = escapeHtml(getCurrencyCatalogUrl(normalizedCurrency) || "URL no configurada");
            const safeMessage = escapeHtml(error?.message || "Error desconocido");
            renderStatus(
                statusRoot,
                "error",
                `No fue posible cargar el catalogo en ${normalizedCurrency} desde <code>${attemptedUrl}</code>. Se mantiene el catalogo en ${previousCurrency}. Detalle: ${safeMessage}`,
                0
            );
            syncView();
        }
    }

    const mayoristasCheck = document.getElementById("mayoristasCheck");
    mayoristasCheck?.addEventListener("change", (event) => {
        state.mayoristas = event.target.checked;
        state.gridPage = 1;
        state.magazinePage = 1;
        syncView();
    });

    sortSelect?.addEventListener("change", (event) => {
        state.sortBy = event.target.value;
        state.gridPage = 1;
        state.magazinePage = 1;
        syncView();
    });

    reloadButton?.addEventListener("click", () => {
        void loadData();
    });

    currencySelect?.addEventListener("change", (event) => {
        void changeCurrency(event.target.value);
    });

    downloadButton?.addEventListener("click", () => {
        if (IS_AVAILABLE_CATALOG()) {
            downloadFile(PDF_AVAILABLE_CATALOG_URL, "catalogo-disponible.pdf");
            return;
        }
        downloadDialog.open();
    });

    mobileFilterToggle?.addEventListener("click", () => {
        filtersRoot?.classList.toggle("is-open");
    });

    shareButton?.addEventListener("click", () => {
        void shareCatalogLink();
    });

    openCartButton?.addEventListener("click", () => {
        if (!IS_AVAILABLE_CATALOG() || cart.hasSelectedWarehouse()) {
            cart.open();
            return;
        }
        warehousePickerDialog.open();
    });

    viewButtons.forEach((button) => {
        button.addEventListener("click", () => {
            if (button.disabled || button.dataset.view === state.view) {
                return;
            }

            state.view = button.dataset.view;
            syncView();
        });
    });

    localFileInput?.addEventListener("change", async (event) => {
        const [file] = event.target.files ?? [];
        if (!file) {
            return;
        }

        try {
            renderStatus(statusRoot, "success", "Leyendo archivo local...", 0);
            const payload = await parseLocalFile(file);
            const products = normalizeCatalog(payload);
            state.allProducts = products;
            filters.hydrate(products);
            renderStatus(statusRoot, "success", `Archivo local cargado con ${products.length} referencias.`, 3000);
        } catch (error) {
            console.error(error);
            renderStatus(statusRoot, "error", "El archivo seleccionado no es un JSON valido para el catalogo.", 0);
        }
    });

    syncViewAvailability();
    syncViewButtons();

    window.addEventListener("resize", () => {
        const isMobileViewport = mobileViewport.matches;
        const breakpointChanged = isMobileViewport !== wasMobileViewport;
        wasMobileViewport = isMobileViewport;

        const switchedToGrid = syncViewAvailability({
            notify: breakpointChanged && isMobileViewport
        });

        if (breakpointChanged || switchedToGrid) {
            syncView();
            return;
        }

        if (state.view === "magazine") {
            magazine.handleResize();
        }
    });

    void loadData();
}

if (typeof document !== "undefined") {
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initApp, { once: true });
    } else {
        initApp();
    }
}
